import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/data-source-template-business-types'

interface Endpoints {
  getAll: NoParamEndpointConstructor
}

export const pythonTypesEndpoints: Endpoints = {
  getAll: () => `${baseUrl}/python-types`,
}
